import { useCallback } from 'react';

import { useSelector } from '@xstate5/react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { useReorderNavigation } from '../../../../hooks/useReorderNavigation';
import { logger } from '../utils';

export const useFinishReorder = () => {
  const { reorderMachineRef } = useGlobalAppState();
  const state = useSelector(reorderMachineRef, (snapshot) => snapshot);
  const { finishReorder } = useReorderNavigation();

  return useCallback(() => {
    logger.info('Finish Reorder', state.context);

    const { restaurantSlug, deliveryOrderDetail } = state.context;
    const addressId = deliveryOrderDetail?.addressId;

    finishReorder(restaurantSlug, addressId);
    reorderMachineRef.send({ type: 'FINISH_REORDER' });
  }, [state.context, finishReorder, reorderMachineRef]);
};
